import React, { FC, memo } from 'react'
import NewNavigationListItem, {
    NewNavigationListItemProps,
} from '@sport1/news-styleguide/NewNavigationListItem'
import Link, { LinkProps } from 'next/link'

type WrappedNavigationListItemProps = NewNavigationListItemProps & LinkProps

const WrappedNavigationListItem: FC<WrappedNavigationListItemProps> = ({
    href,
    webTarget,
    ...rest
}) => {
    if (href)
        return (
            <Link data-testid={`${rest.title}-link`} href={href} target={webTarget}>
                <NewNavigationListItem {...rest} />
            </Link>
        )

    return <NewNavigationListItem {...rest} />
}

export default memo(WrappedNavigationListItem)
